import Cookies from 'js-cookie'

interface PendingInvestmentProcess {
    natural_profile_uid: string
    account_type: string
    asset_uid: string
    asset_title: string
    return_url: string
    investment_amount: number
    pieces: number
    contract_type: number
    incentive_uid: string
    total_amount?: number
    investment_type?: number
    installments?: any
    wallet_amount?: number
    voucher_amount?: number
    voucherify_voucher_uid?: string
    applied_coupons?: string
    step?: number
}

export function getPendingInvestmentCookie(): PendingInvestmentProcess {
    if (Cookies.get('conda_investment_process')) {
        return JSON.parse(Cookies.get('conda_investment_process'))
    } else {
        return null
    }
}

export function setPendingInvestmentCookie(pendingInvestmentProcess: PendingInvestmentProcess): void {
    Cookies.set('conda_investment_process', JSON.stringify(pendingInvestmentProcess), {
        path: '/',
        domain: window.location.hostname,
    })
}

export function deletePendingInvestmentCookie() {
    Cookies.remove('conda_investment_process', { path: '/', domain: window.location.hostname })
}
